import React, { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setBuyButtonArticleNumber } from '../../Actions/BuyButton.action';
import VariantPickerOption from './types/VariantPickerOption';
import VariantPickerProps from './types/VariantPickerProps';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import clsx from 'clsx';

const VariantPickerButtons = ({
  options,
  selectedValue,
}: VariantPickerProps) => {
  const dispatch = useDispatch();

  const { articleNumber } = useTypedSelector((state) => state.buyButton);

  const onClick = useCallback(
    (option: VariantPickerOption) => {
      dispatch(setBuyButtonArticleNumber(option.value));
    },
    [dispatch]
  );

  useEffect(() => {
    if (selectedValue) {
      let option = options.find((opt) => opt.value == selectedValue);
      setTimeout(() => option && onClick(option), 1);
    }
  }, [dispatch, selectedValue, onClick, options]);

  return (
    <div className="flex gap-1">
      {options.map((opt, idx) => (
        <button
          className={clsx(
            'btn btn--outline btn--medium min-w-10 h-10',
            opt.value == articleNumber && 'bg-primary-50'
          )}
          disabled={opt.disabled}
          onClick={() => onClick(opt)}
          key={'variant-picker' + opt.value + idx}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
};

export default VariantPickerButtons;
